<template>
  <div class="click-edit">
    <div v-if="edit == true" class="grouped center">
      <input
        v-focus
        class="click-edit__input"
        type="text"
        :value="valueLocal"
        @blur="
          valueLocal = $event.target.value;
          edit = false;
          $emit('input-save', valueLocal);
        "
        @keyup.enter="
          valueLocal = $event.target.value;
          edit = false;
          $emit('input-save', valueLocal);
        "
        @keyup.esc="edit = false"
      />

      <a
        class="icon-link text-success"
        @click="$emit('input-save', valueLocal)"
      >
        <svg width="1em" height="1em" viewBox="0 0 24 24">
          <path
            d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59L21 7z"
            fill="currentColor"
          ></path>
        </svg>
      </a>

      <a class="icon-link text-error" @click="edit = false"
        ><svg width="1em" height="1em" viewBox="0 0 24 24">
          <path
            d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-1.9 0-3.6.6-4.9 1.7l11.2 11.2c1-1.4 1.7-3.1 1.7-4.9c0-4.4-3.6-8-8-8m4.9 14.3L5.7 7.1C4.6 8.4 4 10.1 4 12c0 4.4 3.6 8 8 8c1.9 0 3.6-.6 4.9-1.7z"
            fill="currentColor"
          ></path></svg
      ></a>
    </div>
    <div v-else class="txt">
      {{ valueLocal }}

      <a class="icon-link" @click="edit = true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          style="vertical-align: -0.125em"
          width="1em"
          height="1em"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 1024 1024"
        >
          <path
            fill="currentColor"
            d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3l-362.7 362.6l-88.9 15.7l15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
          /></svg
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      edit: false,
      valueLocal: this.value,
    };
  },

  watch: {
    value: function () {
      this.valueLocal = this.value;
    },
  },

  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>
<style scoped>
.click-edit__input {
}
.txt {
  padding: 0.8rem 1rem;
  border: 1px solid transparent;
}

.click-edit {
  max-width: 40em;
}

.icon-link {
  /*padding-right: 3em;*/
  position: relative;
  top: 0.125em;
}
</style>
